import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import Background from '@/components/Background.vue';
import SpinnerHolder from '@/components/SpinnerHolder.vue';
import VariableLogo from '@/components/VariableLogo.vue';
import LanguageSelector from '@/components/LanguageSelector.vue';
import MenuService from "../services/MenuService";
import { TypeOrder } from '@/store/state';
let Splashscreen = class Splashscreen extends Vue {
    constructor() {
        super(...arguments);
        this.loading = true;
        this.description = '';
        this.foundRestaurant = false;
        this.languajeSelector = false;
        this.localized = [];
        this.active = true;
    }
    async notFound() {
        this.foundRestaurant = false;
        this.loading = false;
    }
    async showSplashscreen() {
        const menu = this.$store.state.menu;
        if (menu) {
            this.description = menu.description;
            this.active = menu.active;
            this.loading = false;
            this.foundRestaurant = true;
            const localizations = menu.localizations;
            this.localized = menu.localizations;
            if (localizations && localizations.length == 1 && this.active) {
                this.skipSplashscreen(localizations[0]);
            }
            else {
                this.languajeSelector = true;
            }
        }
    }
    skipSplashscreen(localization) {
        this.$store.dispatch('changeCurrency', localization.currency);
        this.$store.dispatch('changeLanguage', localization.language);
        this.$emit('select');
        this.languageSelected();
    }
    languageSelected() {
        this.$router.push('/menu');
    }
    async created() {
        const restaurantIdOrSlug = this.$route.params.restaurantId;
        const menuIdOrSlug = this.$route.params.menuId;
        await this.$store.dispatch('getRestaurant', restaurantIdOrSlug);
        if (!this.$store.state.restaurant) {
            this.notFound();
            return;
        }
        await this.$store.dispatch('getMenu', menuIdOrSlug);
        if (!this.$store.state.menu) {
            await this.notFound();
            return;
        }
        await this.$store.dispatch('setTypeOrder', TypeOrder.LOCAL);
        await MenuService.addViewToMenu(this.$store.state.menu.id);
        await this.$store.dispatch('setNewOrder');
        //await this.showSplashscreen()
        setTimeout(this.showSplashscreen, 2000);
    }
};
Splashscreen = __decorate([
    Component({
        components: {
            Background,
            VariableLogo,
            LanguageSelector,
            SpinnerHolder
        }
    })
], Splashscreen);
export default Splashscreen;
